const FriendStatus = {
    DELETED: 'DELETED',
    DELETED__UNSEEN: 'DELETED__UNSEEN',

    DEACTIVATED: 'DEACTIVATED',
    DEACTIVATED__UNSEEN: 'DEACTIVATED__UNSEEN',

    DELETED_BY_USER: 'DELETED_BY_USER',

    NEW: 'NEW',

    CURRENT: 'CURRENT',
};

module.exports = FriendStatus;
